module.exports =
{

  _init: function ()
  {
    APPLICATION._APPLICATION.search($(".js-url"))
  }

}